import { Box, Typography } from '@mui/material';
import GroupBarChart from '../components/GroupBarChart';
import { useGraficas } from '../hooks/useGraficas';
import { useEffect } from 'react';


export const CargosVsAbonos = () => {

    const { currentYear,  setAño, getMovimientosMensuales, movimientosMensuales } = useGraficas();


    useEffect(() => {
        getMovimientosMensuales(Number(currentYear))
            .then(data => {
                console.log('Datos de movimientos mensuales:', data);
            })
            .catch(err => {
                console.error('Error al obtener los movimientos mensuales:', err);
            });
    }
        , [currentYear]);


    return (
        <Box textAlign="center" display="flex" alignItems="center" flexDirection='column' >
            <Typography variant="h4" component="div" gutterBottom marginY='1em'>
                Grafica Cargos/Abonos
            </Typography>
            <Typography component="div" textAlign='left' width={'100%'} style={{ textIndent: '2rem' }} marginY='0.5em'>
                Mostrar año:
                <select
                    value={currentYear}
                    style={{
                        fontSize: '1rem',
                        padding: '0.5em',
                        borderRadius: '5px',
                        border: '1px solid #AAA',
                        margin: '0.5em',
                        width: '6em'
                    }}
                    onChange={(e) => {
                        const year = e.target.value;
                        setAño(`${year}-01`);
                        console.log(`Año seleccionado: ${year}`);
                    }}
                >
                    {Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - 5 + i).map(year => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>
            </Typography>

            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="clamp(75%, 50vw, 10%)"
                maxWidth={600}
                paddingBottom="10rem"
            >
                <GroupBarChart
                    dataObject={movimientosMensuales}
                    camposDatos={['cargos', 'abonos', 'saldo']}
                    campoTitulo='nomMes'/>
            </Box>

        </Box>
    );



}